import * as Cookies from "js-cookie";
import { Resources } from "../../../../Common/Web.UI/CommonContent/scripts/app/global/resources";
import { App } from "../../../../Common/Web.UI/CommonContent/scripts/app/_app";
import { DynaTrace } from "../../../../Common/Web.UI/CommonContent/scripts/app/dynatrace";
import { ContactEvidence } from "./_contact-evidence";

declare const dtrum: DynaTrace;
export class Evidenz {

    private static cookieEnabled = false;

    static cookiesEnabled(): boolean {
        let cookieEnabled = (navigator.cookieEnabled) ? true : false;

        if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
            document.cookie = "testcookie";
            cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
        }
        return cookieEnabled;
    }

    static setLicensePlateCookie() {
        const d = new Date();
        d.setTime(d.getTime() + (20 * 60 * 1000));
        if ($("#licenseplate_country option:selected").length > 0 &&
            $("#licenseplate_country option:selected").val() != "") {
            Cookies.set("licenseplate_country", $("#licenseplate_country option:selected").val().toString(), { expires: d, secure: true, sameSite: "lax" });
        }

        let checkboxValue = "";
        if ($("#check-speciallicenseplate").is(":checked")) {
            checkboxValue = "on";
        }
        Cookies.set("licenseplate_special", checkboxValue, { expires: d, secure: true, sameSite: "lax" });

        $("#licenseplate").val($("#licenseplate").val().toString().toUpperCase().replace(/–/g, "-").replace(/ /g, ""));
        Cookies.set("licenseplate", $("#licenseplate").val().toString(), { expires: d, secure: true, sameSite: "lax" });
    }

    static isLicensePlateSet() {
        const licenseplate: HTMLInputElement = <HTMLInputElement>document.getElementById("licenseplate");
        const licenseplate_country: HTMLSelectElement = <HTMLSelectElement>document.getElementById("licenseplate_country");
        return licenseplate.value.length > 0 && licenseplate_country != null && licenseplate_country.value !== "";
    }

    static init() {
        Evidenz.cookieEnabled = Evidenz.cookiesEnabled();

        const urlParams = new URLSearchParams(window.location.search);
        // Cookies
        const cookie = Cookies.get("NonEssentialCookiesAccepted");
        const dtcookie = Cookies.get("dtcookie");
        if (!cookie && (urlParams.get("showcookie") == null || urlParams.get("showcookie") !== "false")) {
            App.Common.Dialogs.openCookieModal();
        }

        App.init();
        App.Common.Functions.dockCommunicationWidgetToFooter();
        App.Common.Functions.fixAccessibility();
        ContactEvidence.init();

        if (cookie === "yes" && !dtcookie && typeof (dtrum) !== "undefined") {
            dtrum.enable();
        }

        // Delete old Cookie for "cookies accepted"
        if (Cookies.get("cookieconsent_dismissed")) {
            Cookies.set("cookieconsent_dismissed", "yes", { expires: 0 });
        }

        if (document.getElementById("validitycheckformview") != null) {
            /* Validator */
            const validator = $("#validitycheck-form").validate({
                submitHandler: function () {
                    if ($("#licensePlateStatus").val() === "isSpecial" && !$("#check-speciallicenseplate").is(":checked")) {
                        return false;
                    }
                    if (!Evidenz.cookieEnabled) {
                        // eslint-disable-next-line
                        window.location.href = window.location.href;
                        return false;
                    } else {
                        const maxRequests = parseInt($("#ed-validitycheck").attr("data-max-requests"));
                        let counter: number = parseInt(Cookies.get("evidence-counter")) || 0;
                        if (counter < maxRequests) {
                            counter++;
                            const d = new Date();
                            d.setHours(24, 0, 0, 0);
                            const properties : Cookies.CookieAttributes = { expires: d, domain: "", secure: true, sameSite: "lax" };
                            if (!App.Common.Functions.isLocalEnvironment()) {
                                properties.domain = ".asfinag.at";
                            }
                            Cookies.set("evidence-counter", counter.toString(), properties);
                        } else {
                            $("#limit-error-container").empty().append("<div class=\"asfinag-2column-left\">" + App.Common.Functions.Alerts.getDangerHtml(Resources.ErrorMessages.cookieLimitMessage, "center-block mt-3 mb-3") + "</div>");
                            return false;
                        }
                    }

                    return true;
                },

                rules: {
                    Country: {
                        required: true
                    },
                    LicensePlate: {
                        required: {
                            depends: Evidenz.isLicensePlateSet
                        },
                        fitsLength: {
                            depends: Evidenz.isLicensePlateSet
                        },
                        meetsRegEx: {
                            depends: Evidenz.isLicensePlateSet
                        }
                    },
                    DigitalVignette: {
                        isAtLeastOneCheckboxSelected: true
                    },
                    SpecialToll: {
                        isAtLeastOneCheckboxSelected: true
                    },
                    "mtcaptcha-verifiedtoken": {
                        required: {
                            depends: function () {
                                return document.getElementById("mtcaptcha-verifiedtoken-1") != null;
                            }
                        }
                    }
                },
                messages: {
                    Country: {
                        required: Resources.ErrorMessages.fieldRequiredError
                    },
                    LicensePlate: {
                        required: Resources.ErrorMessages.fieldRequiredError,
                        fitsLength: Resources.ErrorMessages.licenceplateLength
                    },
                    DigitalVignette: {
                        isAtLeastOneCheckboxSelected: Resources.ErrorMessages.checkboxRequiredError
                    },
                    SpecialToll: {
                        isAtLeastOneCheckboxSelected: Resources.ErrorMessages.checkboxRequiredError
                    },
                    "mtcaptcha-verifiedtoken": {
                        required: Resources.ErrorMessages.captchaRequiredError
                    }
                }
            });

            // On load, do show the correct text
            if ($("#licenseplate_country").val() !== null) {
                App.Common.Functions.LicensePlate.ShowInfoText();
                App.Common.Functions.LicensePlate.ShowLicensePlatePlaceHolder();
                if ($("#licenseplate").val().toString().length > 0) {
                    validator.element($("#licenseplate"));
                }
            }

            $("#licenseplate_country").change(function () {
                Evidenz.setLicensePlateCookie();
                App.Common.Functions.LicensePlate.ResetSpecialLicensePlate();
                App.Common.Functions.LicensePlate.ShowLicensePlatePlaceHolder();
                validator.element($("#licenseplate_country"));
                if ($("#licenseplate").val().toString().length > 0) {
                    validator.element($("#licenseplate"));
                }
                App.Common.Functions.LicensePlate.ShowInfoText();
            });
            $("#licenseplate").change(function () {
                Evidenz.setLicensePlateCookie();
                validator.element($("#licenseplate_country"));
                App.Common.Functions.LicensePlate.ResetSpecialLicensePlate();
            });

            $("#check-speciallicenseplate").change(function () {
                Evidenz.setLicensePlateCookie();
                validator.element($("#licenseplate"));
                App.Common.Functions.LicensePlate.ShowInfoText();
                App.Common.Functions.LicensePlate.ShowLicensePlatePlaceHolder();
            });


        }

        if (!Evidenz.cookieEnabled) {
            $("#validitycheckformview").empty();
            $("#validitycheckformview").append("<div class=\"asfinag-2column-left\">" + App.Common.Functions.Alerts.getDangerHtml(Resources.ErrorMessages.activateCookies) + "</div>");
        }

        /**
         * Scroll to top Button
         */
        $(window).scroll(function () {
            if ($(this).scrollTop() > 10) {
                $("#back-to-top").fadeIn();
            } else {
                $("#back-to-top").fadeOut(100);
            }
        });

        /*
         * Trigger resize Event
         */
        /*
        $(window).resize(function () {
            if (this.resizeTO) clearTimeout(this.resizeTO);
            this.resizeTO = setTimeout(function () {
                $(this).trigger("resizeEnd");
            }, 500);
        });
        */

        $(".navbar-header button.navbar-toggle").on("click", function () {
            if (window.innerWidth < 1024) {
                $(".navbar-top ul li:first-child a").focus();
            }
        });

        $(".navbar-top li:visible:last-child").on("focusout", function () {
            if (window.innerWidth < 1024) {
                if (!$(".lang-selector").hasClass("open")) {
                    $(".navbar-header button.navbar-toggle").focus();
                }
            }
        });
        $("#lang-list li:last-child").on("keydown", function (event) {
            if (window.innerWidth < 1024 && event.originalEvent.keyCode === 9 && !event.originalEvent.shiftKey) {
                $(".navbar-header button.navbar-toggle").focus();

            }
        });

        $("#lang-list li").on("keydown", function (event) {
            if (($(event.currentTarget).is(":last-child") && event.originalEvent.keyCode === 9 && !event.originalEvent.shiftKey) ||
                ($(event.currentTarget).is(":first-child") && event.originalEvent.keyCode === 9 && event.originalEvent.shiftKey)) {
                $(".lang-selector a").attr("aria-expanded", "false");
                $(".lang-selector").removeClass("open");
            }
        });

        /* 
         * Set Language Selection to Cookie
         */
        $("#lang-list a").on("click",
            function () {
                const langCode = $(this).data("langcode");
                Cookies.set("epslanguage", langCode, { expires: 365, secure: true, sameSite: "lax" });
            });

        const event = new CustomEvent("Evidence.WebApp.initialized", {
            bubbles: true,
            cancelable: false
        });
        document.dispatchEvent(event);

    }
}

document.addEventListener("DOMContentLoaded",
    () => {
        Evidenz.init();
    });
Resources.init();